import clsx, { type ClassValue } from "clsx";

import { twMerge } from "tailwind-merge";
import { differenceInCalendarDays } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Calculate city tax based on adults, arrival/departure dates, and property tax rate
 * Based on backend logic: only adults aged 18-70 pay tax, multiplied by number of days
 */
export function calculateCityTax(
  arrivalDate: string | Date | null,
  departureDate: string | Date | null,
  numberOfAdults: number,
  propertyTaxPerPersonPerDay: number
): number {
  if (!arrivalDate || !departureDate || numberOfAdults <= 0 || propertyTaxPerPersonPerDay <= 0) {
    return 0;
  }

  // Calendar nights, also across a change to or from summer time.
  const totalDays = differenceInCalendarDays(new Date(departureDate), new Date(arrivalDate));
  
  if (totalDays <= 0) {
    return 0;
  }

  // Assuming all adults are aged 18-70 (frontend doesn't have age data)
  // In a real implementation, you might want to get this from backend
  const taxableAdults = numberOfAdults;
  
  return totalDays * propertyTaxPerPersonPerDay * taxableAdults;
}
